import React from "react";

type AppContextValue = {
  state: Record<string, any>;
  dispatch: React.Dispatch<any>;
};

const Context = React.createContext<AppContextValue>({
  state: {},
  dispatch: () => undefined,
});
export  const {Provider} = Context;

export default Context;
